import React from 'react';
import { useTranslation } from 'react-i18next';

// Path data is the official Central Bank of Oman Omani Rial sign.
// Three weights are provided to match surrounding text-weight (regular vs. bold totals etc.).
const GLYPHS = {
  light: {
    viewBox: '0 0 729.6 365.93',
    d: 'M241.67,213.77c-.63-49.2,11.44-95.41,35.76-137.75C313.47,13.28,353.02-6.48,421.55,28.87c10.67,5.5,53.6,35.43,57.81,44.54,5.03,10.87-27.48,103.87-29.11,122.3-34.69-37.51-99.37-98.66-154.85-69.62-45.05,23.58-12.02,62.54,11.46,87.68h409.36l-26.41,47.64h-332.5c-.31,1.8.87,3.3,2.53,4.6,12.44,9.72,80.97,39.54,94.75,39.54h210.71l-26.89,48.94H13.37l26.91-48.94h253.38l-37.11-44.13H64.75l26.41-47.64h150.51Z',
  },
  medium: {
    viewBox: '0 0 741.36 415.06',
    d: 'M259.9,219.89c-.63-49.2,11.44-95.41,35.76-137.75C331.7,19.4,371.24-.36,439.78,34.99c10.67,5.5,53.6,35.43,57.81,44.54,5.03,10.87-27.48,103.87-29.11,122.3-34.69-37.51-99.37-98.66-154.85-69.62-45.05,23.58-12.02,62.54,11.46,87.68h406.25l-39.14,70.23-289.2-2c-1.11,4.66.87,3.3,2.53,4.6,12.44,9.72,80.97,31.54,94.75,31.54l172.05,1.99-39.49,71.25H10.03l39.24-71.24h272.14l-37.11-36.13H69.33l39.23-70.23h151.33Z',
  },
  bold: {
    viewBox: '0 0 798.31 440.47',
    d: 'M81.06,299.73l45.71-82.79,156.27-.37c-1.56-58.06,20.14-128.93,58.17-173.5,46.34-54.3,115.4-27.63,161.54,11.98,5.82,4.99,22.82,20.21,22.58,26.93l-30.86,117.94c-36.47-40.56-83.3-85.47-143.16-75.47-11.27,1.88-26.48,12.6-32.28,22.36-14.43,24.25,15.49,53.68,31.72,69.75h437.78l-46.1,83.16h-309.95c13.29,11.36,32.13,21.87,48.28,28.94,8.46,3.7,40.8,16.2,47.95,16.2h188.69l-46.1,83.16H9.77l46.33-83.16h291.08l-33.27-45.15H81.06Z',
  },
};

// Inline SVG of the Omani Rial sign. Inherits color via `currentColor`,
// scales with font-size (height = 1em), keeps aspect ratio.
const OmrSign = ({ weight = 'medium', label, style, ...rest }) => {
  const { t } = useTranslation();
  const glyph = GLYPHS[weight] || GLYPHS.medium;
  const ariaLabel = label ?? t('currency.omr.ariaLabel', 'Omani Rial');

  return (
    <svg
      role="img"
      aria-label={ariaLabel}
      viewBox={glyph.viewBox}
      preserveAspectRatio="xMidYMid meet"
      fill="currentColor"
      focusable="false"
      style={{
        height: '1em',
        width: 'auto',
        flexShrink: 0,
        ...style,
      }}
      {...rest}
    >
      <path d={glyph.d} />
    </svg>
  );
};

export default OmrSign;
